import MailFooter from "./MailFooter";
import MailReplyTo   from "./MailReplyTo";

class MailSetting {
  constructor(
    private readonly _replyTo: MailReplyTo = new MailReplyTo(),
    private readonly _footer: MailFooter = new MailFooter(),
  ) {
  }

  get replyTo() {
    return this._replyTo;
  }

  get footer() {
    return this._footer;
  }
}

export default MailSetting;
